/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：路由配置文件
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

// 引入 Vue 
import Vue from 'vue'
import VueRouter from 'vue-router'

// 1.创建页面组件
// 在SRC文件 创建页面  
import Home 	from '../views/Home.vue'
import Index 	from '../views/Index.vue'
import M01 		from '../views/M01.vue'
import M02 		from '../views/M02.vue'
import Main 	from '../views/Main.vue'
import User 	from '../views/User.vue'
import UserInfo from '../views/UserInfo.vue'
import Login 	from '../views/Login.vue'
import MyInfo 	from '../views/MyInfo.vue'
import RegPartner 	from '../views/RegPartner.vue'
import RegStaff 	from '../views/RegStaff.vue'
import RegVender 	from '../views/RegVender.vue'
import ReadLegalNotice 	from '../views/ReadLegalNotice.vue'
import ReadSignAgree 	from '../views/ReadSignAgree.vue'

// 解决路由重复点击报错
// ---------------------------------------------
// 保存原始方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 重写push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

// 重写replace方法
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}
// ---------------------------------------------

// 加载 Vue 路由
Vue.use(VueRouter)

// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const routes = [
	// 主路由项目
	{
		path: '/', 
		component: Main,
		name: 'main',
		redirect: '/Home',
		//mode: 'history', // 关键：从 'hash' 改为 'history'
		// 子路由项目
		children: [
			// 也可以采用这个链接
			//{ path: '/', component: Home },
			{ 
				path: '/Home', 
				name: 'Home', 
				component: Home 
			},
			{
				path: '/myInfo',
				name: 'myInfo',
				component: MyInfo,
			},
			{
				path: '/readLegalNotice',
				name: 'readLegalNotice',
				component: ReadLegalNotice,
			},
			{
				path: '/readSignAgree',
				name: 'readSignAgree',
				component: ReadSignAgree,
			},
			/*{ path: '/home', 
					name: 'home', component: Home },
			
			{ path: '/m01', 
					name: 'm01', component: M01 },
			{ path: '/m02', 
					name: 'm02', component: M02 },
			{ path: '/userinfo', 
					name: 'userinfo', component: UserInfo },
			{ path: '/user', 
					name: 'user', component: User }*/
		]
	},
	{
		path: '/login',
		name: 'loginUser',
		component: Login,
	},
	{
		path: '/regPartner',
		name: 'regPartner',
		component: RegPartner,
	},
	{
		path: '/regStaff',
		name: 'regStaff',
		component: RegStaff,
	},
	{
		path: '/regVender',
		name: 'regVender',
		component: RegVender,
	},
	/* { path: '/home00', component: Home }, */
]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
	routes // (缩写) 相当于 routes: routes
})

// 4.将当前实例对外进行暴露
export default router